import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { RuleSearchesTableData } from "../../state/SearchManagerV2/RuleSearchesTableData";

const updateRuleSearchesTableV2Reducer: Reducer<RuleSearchesTableData> = (state: RuleSearchesTableData = new RuleSearchesTableData(), action: Action<ActionType, RuleSearchesTableData>) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_V2_SEARCHES_RESULTS_FETCHED:
      return { ...state, records: action.data.items, totalItems: action.data.totalItems };
    case ActionType.SEARCH_MANAGER_V2_SEARCHES_RESULTS_UPDATED:
      return { ...state, records: action.data.items, totalItems: action.data.totalItems };
    case ActionType.SEARCH_MANAGER_V2_SEARCHES_RESULTS_REFRESHED:
      return { ...state, ruleSearchesData: {...action.data} };
    case ActionType.SEARCH_MANAGER_V2_SEARCHES_RESULTS_RESETED:
      return { ...state, ruleSearchesData: [] }
    case ActionType.SEARCH_MANAGER_V2_SEARCHES_FORM_UPDATED:
    let result = { ...state, records: action.data.items, totalItems: action.data.totalItems };
    return result;
    default:
      return state;
  }
};

export default updateRuleSearchesTableV2Reducer;
